export default __webpack_public_path__ + "static/media/pyposition_84a.a1f12ec7.png";